import React from "react";
import { Grid, Carousel, Row, Col } from "react-bootstrap";
import './Home.css';
import Product from '../components/Product';
import Partners from '../components/Partners';
import Contact from '../components/Contact';

const BANNERS = [
  { image: "/images/banner3.jpg", title: "TU TRANQUILIDAD", subtitle: "Nuestro norte" },
  { image: "/images/banner2.jpg", title: "TU INVERSION", subtitle: "Nuestra prioridad" },
  { image: "/images/banner1.jpg", title: "TU SEGURIDAD", subtitle: "Nuestro objetivo" }
];

export default function Home() {
  return (
    <div className="Home">
      <section>
        <Carousel>
          {BANNERS.map(banner => (
            <Carousel.Item key={banner.image}>
              <img alt="" src={banner.image} width="100%" height={200} />
              <Carousel.Caption>
                <h3>{banner.title}</h3>
                <p>{banner.subtitle}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
      <section id="Quienes" className="about home-content">
        <Grid>
          <h2>Quiénes somos</h2>
          <Row>
            <Col md={6} xs={12}>
              <div className="textwidget">
                <p className="lead-text text-center">
                  Somos un equipo de profesionales y técnicos altamente calificados con amplia experiencia atendiendo
                  las necesidades de nuestros asegurados, asesorando en la contratación, como así también en el
                  compromiso integral en el proceso del Siniestro.
                </p>
              </div>
            </Col>
            <Col md={6} xs={12}>
              <div className="img1widget">
                <p className="text-center">
                  <img className="img1" src="/images/img1.jpg" alt="Equipo Map Seguros" />
                </p>
              </div>
            </Col>
          </Row>
        </Grid>
      </section>
      <section className="product home-content" id="Productos">
        <h2 className="text-center">Nuestros Productos</h2>
        <Product />
      </section>
      <Partners />
      <section className="contact home-content">
        <Grid>
          <div className="Contacto">
            <h2 id="Contacto">Contacto</h2>
            <Contact />
          </div>
        </Grid>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Home.js